import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { IconChevronLeft } from "../../../assets/icons";

function SkeletonOrderItemShow() {
  return (
    <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">
      <Col xs={12} lg={4} className=" mt-2">
        <Card className="w-100 rounded-4">
          <Card.Body className="px-3">
            <Row className=" mt-2">
              <Col xs="6">
                <Skeleton width="100%" height={17} />
              </Col>
              <Col xs="6">
                <Skeleton width="100%" height={17} />
              </Col>
            </Row>
            <Row className=" mt-1">
              <Col xs="6">
                <Skeleton width="80%" height={15} />
              </Col>
            </Row>
            <Row className=" mt-1">
              <Col xs="6">
                <Skeleton width="100%" height={15} />
              </Col>
            </Row>
            <div className="pr-2 arrow-left">
              <div className="bg-light-gray text-center rounded-4 border ps-2 pe-1 fs-085 small-svg-1">
                مشاهده
                <IconChevronLeft fillColor="dark" />
                {/* مشاهده <ChevronLeft size={10} className="" /> */}
              </div>
            </div>
            <div className="pt-3 mt-2 border-dashed-top">
              <Row className="mb-2 px-3">
                <Col xs="auto" className=" p-0 m-0 pe-2">
                  <Skeleton width={50} height={38} />
                </Col>
                <Col xs="auto" className=" p-0 m-0 pe-2">
                  <Skeleton width={50} height={38} />
                </Col>
                <Col xs="auto" className=" p-0 m-0 pe-2 ">
                  <Skeleton width={50} height={38} />
                </Col>
              </Row>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </SkeletonTheme>
  );
}

export default SkeletonOrderItemShow;
